export enum ChatEvents {
	chatMessageIncome = 'chat_message_income',
    chatMessageSent = 'chat_message_sent',
    chatReset = 'chat_reset'
}